export interface SpecialInstructionsProps {
  specialInstructions?: string;
}

export const SpecialInstructions = ({
  specialInstructions,
}: SpecialInstructionsProps) => {
  return (
    <div className="w-full">
      <p className="text-[15px] text-[#727272] max-w-[310px] break-words text-left">
        {specialInstructions ? `"${specialInstructions}"` : ""}
      </p>
    </div>
  );
};
